module.exports = __webpack_public_path__ + "static/media/Snapshot Vid_1731924856585.e1503389. Script 10 2024";